import React from "react";

export const Stepper = ({ onClick, children, testid }) => (
  <button type="button" data-testid={testid} onClick={onClick} className="w-10 h-10 flex items-center justify-center border border-white/15 hover:border-[#FF5722] hover:text-[#FF5722] text-white/70 text-2xl leading-none transition-all duration-200">{children}</button>
);

export const ShotBtn = ({ onClick, testid, made, children }) => (
  <button type="button" data-testid={testid} onClick={onClick}
    className={`py-3 sm:py-4 font-bold uppercase tracking-wide text-sm sm:text-base transition-all duration-200 active:scale-95 ${
      made ? "bg-[#FF5722] hover:bg-[#FF7043] text-black" : "border border-white/15 text-white/70 hover:border-[#FF3B30] hover:text-[#FF3B30]"
    }`}>{children}</button>
);

export const StatBtn = ({ onClick, testid, children, accent = "#FF5722" }) => (
  <button type="button" data-testid={testid} onClick={onClick}
    style={{ "--acc": accent }}
    className="py-3 border border-white/15 bg-[#1A1A1A] text-white/75 hover:border-[var(--acc)] hover:text-[var(--acc)] font-bold uppercase tracking-wide text-sm transition-all duration-200 active:scale-95">{children}</button>
);
